import { render, staticRenderFns } from "./MediaDetail.vue?vue&type=template&id=4451c9d6&scoped=true&"
import script from "./MediaDetail.vue?vue&type=script&lang=js&"
export * from "./MediaDetail.vue?vue&type=script&lang=js&"
import style0 from "./MediaDetail.vue?vue&type=style&index=0&id=4451c9d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4451c9d6",
  null
  
)

export default component.exports